module.exports = __webpack_public_path__ + "static/media/pizzaz.285ce86a.gif";